import { render, staticRenderFns } from "./dialogCopyAuthority.vue?vue&type=template&id=48a252c5&scoped=true&"
import script from "./dialogCopyAuthority.vue?vue&type=script&lang=js&"
export * from "./dialogCopyAuthority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a252c5",
  null
  
)

export default component.exports